import { render, staticRenderFns } from "./m-work-order-notes.html?vue&type=template&id=4d8f6c2c&scoped=true&"
import script from "./m-work-order-notes.ts?vue&type=script&lang=js&"
export * from "./m-work-order-notes.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f6c2c",
  null
  
)

export default component.exports